// removed by extract-text-webpack-plugin
module.exports = {"Search":"_39ejmBra9BPAbYZ3X2cqSH","searchOpen":"_2uArzFD8bJ4bdulKQgJ858 _39ejmBra9BPAbYZ3X2cqSH","centered":"_3KjW44fwSOV14pKeWbGr2U","searchContainer":"_3Sn6kWJzDezc4nT7fCILPC","searchInput":"_2smrpDtR-q_FXTUxQOZYmy","buttonSubmit":"mQhlcYafZ441e4meJshNK","searchIcon":"Man4gAntlOnO3vp1hYRMu","searchSuggestions":"_2tJbm91JkVaRA3iuGp1G7n","suggestion":"_3w7AVLse8CNDeGgocRooNb","suggestionTitle":"_1vn63FgEYz9F7WMEOjfb2b","suggestionCategory":"_1qRNCGPxybsq-TMid5uffo","spacer":"_2e3VGzPgUtrD_QSXMaQ5xh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/Search.css
// module id = 112
// module chunks = 8